'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import personActions from 'actions/PersonActionCreators';
import personStore from 'stores/PersonStore';
import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListSection from 'components/base/list-components/ListSection';
import ListItem from 'components/base/list-components/ListItem';

import _ from 'underscore';
import utils from 'services/utils';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class PayAdviceWidget extends React.Component {

    constructor(props) {
        super(props);
        this._onPayAdviceDownload = this._onPayAdviceDownload.bind(this);
        this._PayAdviceDownload = this._PayAdviceDownload.bind(this);
        this.state = {
            currentDate: moment().add(12, 'months'),
            downloading: false,
        };
    }

    componentDidMount() {

        personStore.addDownloadPersonPayAdvicePdfListener(this._onPayAdviceDownload);
    
        var _this = this;
        setTimeout(function () {
            personActions.getSinglePersonPayAdvices(_this.props.person.Id,  {
                FinancialYearFrom: (new Date().getFullYear() - 2).toString() + "-01-01",
                FinancialYearTo: _this.state.currentDate.format(appConstants.dates.formats.SERVER_POST_FORMAT), 
                pageSize : 1,
                pageNum: 1,       
            });
        }, 0);
    }

    componentWillUnmount() {
        personStore.removeDownloadPersonPayAdvicePdfListener(this._onPayAdviceDownload);
    }
 
    _onPayAdviceDownload(event) {
        this.setState({downloading:false});
        var _this = this;
        setTimeout(function () {
            _this._PayAdviceDownload();
        }, 0);
    }

    _PayAdviceDownload() {  
        this.setState({downloading:true});
        personActions.getSinglePersonPayAdvicePdf(
            this.props.person.Id,
            {
                payAdvicePDFId: this.props.person.payAdvices.items[0].PayAdvicePDFId,              
                periodEndDate: this.props.person.payAdvices.items[0].PeriodEnd,
            }
        );
    }


    render() {

        var hide = true;
        var payAdviceContent = [];
        var link = "";
        var heading = "Latest Pay Advice";
        var error = null;

        if (this.props.person && this.props.person.payAdvices && this.props.person.payAdvices.items && this.props.person.payAdvices.items.length > 0 ) {
            link = "/members/" + this.props.person.Id + "/pay-advices-summaries/";

            var downloadButton = (
                <button className="button--plain add-button" onClick={this._onPayAdviceDownload}>
                    <i className="icon-attachments" style={{color:'#fff'}} />
                </button>
            );

            payAdviceContent.push(
                <ListItem 
                    key="0"
                    colorName="#fff"
                    heading={"Period: " + utils.formatDateMinimal(moment.utc(this.props.person.payAdvices.items[0].PeriodStart)) + " - " + utils.formatDateMinimal(moment.utc(this.props.person.payAdvices.items[0].PeriodEnd))} 
                    downloading={this.props.person.payAdvices.loading && this.state.downloading}
                    inverseColours
                    actions={downloadButton}
                    id={this.props.id} 
                />
            );

            hide = false;
        } else if (this.props.person && this.props.person.payAdvices && this.props.person.payAdvices.error) {
            error = heading; 
        }
   
        
        return (
            
            <PageSection
                id="pay-advice--widget"
                hideSection={hide}
                backgroundColorClass="background-color-financial"
            >
                <List 
                    id={this.props.id} 
                    hasColoredBackground 
                    heading={heading} 
                    link={link}
                    error={error} 
                    icon="icon-pay-advice-inverse"
                >
                    
                    <ListSection>
                        {payAdviceContent}
                    </ListSection>
                </List>
            </PageSection>
            
        );

    }
}

PayAdviceWidget.propTypes = propTypes;

export default PayAdviceWidget; 